import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'

import toastStore from '@/stores/toast-store.js'
import formValidator from '@/mixins/form-validator.js'
import PrefixesMixin from '@/mixins/prefixes.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'

import AddDeliveryRequestSummary from '@/vcs/_shared/modals/add-delivery-request-summary/cmp.vue'

export default {
  name: 'AddDeliveryRequestComment',
  extends: BaseModal,
  mixins: [formValidator, PrefixesMixin, CurrentUserResolver],
  data: function () {
    return {
      comment: '',
    }
  },
  watch: {
    commentLenght: {
      handler: function () {
        this.commentLenght >= 70 ? (this.comment = this.comment.slice(0, 70)) : null
      },
    },
  },
  computed: {
    commentLenght() {
      return this.comment.length
    },
  },
  methods: {
    addComment(e) {
      !!e ? e.preventDefault() : null
      this.openSummaryModal()
    },

    openSummaryModal() {
      this.$store.commit('modal/open', {
        cmp: AddDeliveryRequestSummary,

        animation: 'slide-left-modal',
        data: {
          collectionPoint: this.data.collectionPoint,
          phonePrefix: this.data.phonePrefix,
          phone: this.data.phone,
          comment: this.comment,
        },
      })
    },
  },
}
